import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = 'Pariwartan Sharma | Python Django & Full Stack Developer',
  description = 'Pariwartan Sharma is a Python Django & Laravel Full Stack Developer based in Pokhara, Nepal. Leo Club President, Campus Director, and passionate tech leader.',
  keywords = 'Pariwartan Sharma, Python Django Developer, Laravel Developer, Full Stack Developer, Pokhara Nepal',
  image = 'https://pariwartansharma.com.np/og-image.jpg',
  url = 'https://pariwartansharma.com.np',
  type = 'website',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHead;
